import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseSiteService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Chart, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { take } from 'rxjs/operators';
import { SharedService } from 'src/app/shared/services/shared.service';
import { CommonUtils } from 'src/app/shared/utils/common.utils';
import { CustomInfluenzaService } from '../custom-influenza.service';
@Component({
  selector: 'app-flu-charts',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './flu-charts.component.html',
  styleUrls: ['./flu-charts.component.scss'],
})
export class FluChartsComponent implements OnInit, OnDestroy {
  @ViewChild('chartCanvas') reservationChart: Chart;
  @ViewChild(BaseChartDirective) fluchart: BaseChartDirective;
  @Input() orderStatus: string;
  @Input() orderStatusDisplay: string;
  @Input() stsFlag: boolean = false; //by default stsflag kept false
  @Input() flupara: any;
  @Output() manageSts = new EventEmitter<any>();
  chart: any;
  xlsDataArr: any = [];
  orderHistory: any = [];
  productsArray: any = [];
  totalDoses: any = 0;
  totalUnits: number = 0;
  entriesForChart: any = [];
  chartTableArray: any = [];
  duplicateQuantityStatusArray: any = [];
  chartsBgColorArray: any = [];
  statusInChrtsDisplay: any = 'Shipped';
  fullTrackingUrl: any = '';
  chartPopoverData: any = [];
  chartStatusPopoverData: any;
  hoveredStatus: string;
  statusColorCode: string;
  selectedStatus: string;
  showEditCTAShip: boolean = true;
  // doughnutChartOptions: ChartOptions<'doughnut'>;
  doughnutChartOptions: any;
  colorsArr = [
    {
      status: 'Shipped',
      color: '#62D488',
    },
    {
      status: 'Pending',
      color: '#7A00E6',
    },
    {
      status: 'Scheduled',
      color: '#23004C',
    },
    {
      status: 'In process',
      color: '#8ED8EA',
    },
    {
      status: 'TBD',
      color: '#C7C8CA',
    },
    {
      status: 'Cancelled', //added for now as discussed with Vaishak, as it was showing green in table but blank in pie chart
      color: '#D3D3D3',
    },
    {
      status: 'Open', //added for now as discussed with Vaishak, as it was showing green in piechart and blue in table
      color: '#2EA857',
    },
    {
      status: 'Completed', ////added for now as discussed with Vaishak, as it was showing green in table but blank in pie chart
      color: '#04832e',
    },
  ];

  public chartColors: any[] = [{ backgroundColor: this.chartsBgColorArray }];
  public doughnutChartLabels: string[] = [];
  public doughnutChartData: any = [];
  public doughnutChartType: ChartType = 'doughnut';

  dosesInChartDisplay: any = 0;
  url: any;
  urlPath: any;
  chartSubscriber: any;
  consignmentEntries: any = [];
  reservationTableData: any = [];
  reservationData: any = [];
  orderDetails: any;
  showPieChart: boolean = false;
  chartCenterUnits: number = 0;
  chartCenterDoses: number = 0;
  chartCenterStatus: string;
  chartPrevCenterUnits: number = 0;
  chartPrevCenterDoses: number = 0;
  chartPrevCenterStatus: string;
  chartCenterData: any;
  popupStatus: boolean = false;
  popupTimeout: any;
  baseSiteId: string;
  doughnutDataSet: {
    data: any[];
    backgroundColor: any[];
    hoverBackgroundColor: any[];
    labels: any[];
  };
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly ref: ChangeDetectorRef,
    private readonly sharedService: SharedService,
    private readonly user: UserAccountFacade,
    private readonly influenzaService: CustomInfluenzaService,
    private modal: NgbModal,
    private cdr: ChangeDetectorRef,
    private baseSiteService: BaseSiteService
  ) {}

  ngOnInit() {
    this.baseSiteService
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.url = this.activatedRoute?.url;
    this.urlPath = this.url?._value[this.url?._value.length - 1]?.path;
    if (this.urlPath === 'reservation-overview') {
      this.initializeChart();
      const data = this.sharedService.getSessionStorage('fluOverviewData');
      this.orderDetails = data;
      this.orderDetails.entries = this.orderDetails.entries.filter(
        (element) => element?.quantityStatus != 'Cancelled'
      );
      this.influenzaChartDataNew2(this.orderDetails);
    } else {
      this.chartSubscriber =
        this.influenzaService.detailedReservation.subscribe((res) => {
          this.initializeChart();
          if (res) {
            const data =
              this.sharedService.getSessionStorage('fluOverviewData');
            this.orderDetails = data;
            this.orderDetails.entries = this.orderDetails.entries.filter(
              (element) => element?.quantityStatus != 'Cancelled'
            );
            //Filtering hideRow as false entries (for splitting scenario)
            // if(this.orderDetails?.entries){
            //   this.orderDetails.entries = this.orderDetails.entries.filter(element => !(element?.hideRow && element?.quantityStatus =='TBD'));
            //   //this.orderDetails.entries = this.orderDetails.entries.filter(element => ((!element?.hideRow && !element?.splittedRow) || (element?.hideRow && element?.splittedRow)));
            // }
            // this.influenzaChartData(this.orderDetails);
            // this.influenzaChartDataNew(this.orderDetails);
            this.influenzaChartDataNew2(this.orderDetails);
          }
        });
    }
  }
  ngOnDestroy() {
    this.chartSubscriber?.unsubscribe();
  }

  initializeChart() {
    let that = this;
    this.doughnutChartOptions = {
      // cutoutPercentage: 65,
      cutout: '65%',
      // legend: {
      //   display: false,
      // },
      // hover: {
      onHover: function (event, elements) {
        that.chartCenterData = {
          units: that.chartCenterUnits,
          doses: that.chartCenterDoses,
          status: that.chartCenterStatus,
        };
        // if (event.type == 'mouseout') {
        //   console.log('mouseout');
        //   that.popupStatus = false;
        //   that.chartCenterUnits = that.chartPrevCenterUnits;
        //   that.chartCenterDoses = that.chartPrevCenterDoses;
        //   that.chartCenterStatus = that.chartPrevCenterStatus;
        //   clearTimeout(that.popupTimeout);
        //   that.popupTimeout = setTimeout(() => {
        //     if (that.popupStatus == false) {
        //       document.getElementById('popup').style.display = 'none';
        //     }
        //   }, 2000);
        //   that.cdr.detectChanges();
        // } else {
        if (event?.type == 'mousemove') {
          // that.popupStatus = true;
          if (elements?.length > 0) {
            that.popupStatus = true;
            // that.hoveredStatus = elements[0]['_model']['label'];
            //_model and laebl details are not coming in elements in upgraded version

            if (elements[0]?.element?.options) {
              that.hoveredStatus = that.getStatusFromColor(
                elements[0]?.element?.options?.backgroundColor
              );
            }

            that.setStatusColorCode(that.hoveredStatus);
            // that.chartStatusPopoverData = that.chartPopoverData.filter(
            //   (element) => element.status == elements[0]['_model']['label']
            // );
            that.chartStatusPopoverData = that.chartPopoverData.filter(
              (element) => element.status == that.hoveredStatus
            );
            const result = that.groupAndSumUnits(that.chartStatusPopoverData);
            that.chartStatusPopoverData = result;
            that.chartCenterUnits = that.chartStatusPopoverData.reduce(
              (total, obj) => obj.productUnit + total,
              0
            );
            that.chartCenterStatus = that.hoveredStatus;
            that.cdr.detectChanges();
            document.getElementById('popup').style.display = 'block';
          } else {
            that.popupStatus = false;
            that.chartCenterUnits = that.chartPrevCenterUnits;
            that.chartCenterDoses = that.chartPrevCenterDoses;
            that.chartCenterStatus = that.chartPrevCenterStatus;
            clearTimeout(that.popupTimeout);
            that.popupTimeout = setTimeout(() => {
              if (that.popupStatus == false) {
                document.getElementById('popup').style.display = 'none';
              }
            }, 2000);
            that.cdr.detectChanges();
          }
        } else if (event?.type == 'mouseout') {
          that.popupStatus = false;
          that.chartCenterUnits = that.chartPrevCenterUnits;
          that.chartCenterDoses = that.chartPrevCenterDoses;
          that.chartCenterStatus = that.chartPrevCenterStatus;
          clearTimeout(that.popupTimeout);
          that.popupTimeout = setTimeout(() => {
            if (that.popupStatus == false) {
              document.getElementById('popup').style.display = 'none';
            }
          }, 2000);
          that.cdr.detectChanges();
        }
      },
      // },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      maintainAspectRatio: false,
      aspectRatio: 1,
      responsive: false,
    };
  }
  showHidePopup(value) {
    this.popupStatus = value;
    if (value) {
      document.getElementById('popup').style.display = 'block';
    } else {
      document.getElementById('popup').style.display = 'none';
    }
  }
  openShippingPopup(content, status) {
    //As checked in staging, modal is opening only for shipped/completed.
    if (status == 'Completed' || status == 'Shipped') {
      this.modal.open(content, {
        centered: true,
      });
    }
  }
  dismissModal() {
    this.modal.dismissAll();
  }

  influenzaChartDataNew2(orderDetails) {
    let uniqueConsignArr = [];
    this.chartPopoverData = [];
    this.chartStatusPopoverData = [];
    if (orderDetails != null || orderDetails != undefined) {
      //A) Taking consignment data
      if (orderDetails?.consignments?.length > 0) {
        this.orderDetails?.entries?.forEach((element, index) => {
          let matchedConsignEntries = orderDetails['consignments'].filter(
            (cons) =>
              cons?.entries[0]?.orderEntry?.product?.code ==
                element.product.code && !cons?.alreadyUsed
          );
          if (matchedConsignEntries?.length > 0) {
            matchedConsignEntries?.forEach((matchedconsignment) => {
              matchedconsignment.alreadyUsed = true;
              // now since split multiple entries is there for same product,due to this, it is getting pushed multiple times
              // let existingEntry =  this.chartPopoverData.find(item => item?.productCode==matchedconsignment?.entries[0]?.orderEntry?.product?.code
              //     && item?.productUnit == matchedconsignment?.entries[0]?.shippedQuantity
              //     && item?.status == matchedconsignment?.entries[0]?.orderEntry?.quantityStatus);
              // if(!existingEntry) {
              let dataObj = {};
              dataObj['productCode'] =
                matchedconsignment?.entries[0]?.orderEntry?.product?.code;
              dataObj['productName'] = matchedconsignment?.entries[0]
                ?.orderEntry?.product?.variantProductDescription
                ? matchedconsignment?.entries[0]?.orderEntry?.product
                    ?.variantProductDescription
                : matchedconsignment?.entries[0]?.orderEntry?.product
                    ?.variantOptions?.length > 0
                ? matchedconsignment?.entries[0]?.orderEntry?.product
                    ?.variantOptions[0]?.description
                : matchedconsignment?.entries[0]?.orderEntry?.product
                    ?.description;
              dataObj['productName'] = dataObj['productName']?.replace(
                /<[^>]*>?/gm,
                ''
              );
              dataObj['productUnit'] =
                matchedconsignment?.entries[0]?.shippedQuantity;
              dataObj['productDose'] =
                matchedconsignment?.entries[0]?.shippedQuantity *
                matchedconsignment?.entries[0]?.orderEntry?.product
                  ?.quantityPerUnit;
              // dataObj['status'] = matchedconsignment?.entries[0]?.orderEntry?.quantityStatus;

              //Quantity that is shipped will either have status as shipped or completed.
              //sometimes below quantityStatus is "in process" because not all quantities are shippped
              if (
                matchedconsignment?.entries[0]?.orderEntry?.quantityStatus?.toLowerCase() ==
                  'shipped' ||
                matchedconsignment?.entries[0]?.orderEntry?.quantityStatus?.toLowerCase() ==
                  'completed'
              ) {
                dataObj['status'] =
                  matchedconsignment?.entries[0]?.orderEntry?.quantityStatus;
              } else {
                dataObj['status'] = 'Shipped';
              }
              this.chartPopoverData.push(dataObj);

              //B)Taking difference qty of consignments if any from entries
              // let differenceQty = matchedconsignment?.entries[0]?.quantity - matchedconsignment?.entries[0]?.shippedQuantity
              let differenceQty =
                matchedconsignment?.entries[0]?.orderEntry?.quantity -
                matchedconsignment?.entries[0]?.shippedQuantity;
              //now if not all quantities under consignment are shipped, remaining quantity status to get from entries
              if (differenceQty > 0) {
                let dataObj = {};
                dataObj['productCode'] = element?.product?.code;
                /*dataObj['productName'] = element?.product?.variantOptions?.length> 0 ?
                  element?.product?.variantOptions[0]?.description : element?.product?.description;*/
                dataObj['productName'] = element?.product
                  ?.variantProductDescription
                  ? element?.product?.variantProductDescription
                  : element?.product?.variantOptions?.length > 0
                  ? element?.product?.variantOptions[0]?.description
                  : element?.product?.description;
                dataObj['productName'] = dataObj['productName']?.replace(
                  /<[^>]*>?/gm,
                  ''
                );
                dataObj['productUnit'] = differenceQty;
                dataObj['productDose'] =
                  differenceQty * element?.product?.quantityPerUnit;
                dataObj['status'] = element?.quantityStatus;
                this.chartPopoverData.push(dataObj);
              }
              // }
            });
          }

          if (index + 1 === this.orderDetails?.entries.length) {
            uniqueConsignArr = orderDetails['consignments']?.reduce(
              (unique, o) => {
                if (
                  !unique?.some(
                    (obj) =>
                      obj?.entries[0]?.orderEntry?.entryNumber ===
                        o?.entries[0]?.orderEntry?.entryNumber &&
                      obj?.statusDate === o?.statusDate &&
                      obj?.status === o?.status
                  )
                ) {
                  unique.push(o);
                }
                return unique;
              },
              []
            );
            uniqueConsignArr?.forEach((element, index) => {
              orderDetails?.consignments?.forEach((obj, j) => {
                if (
                  obj.code != element?.code &&
                  obj.entries[0]?.orderEntry?.entryNumber ===
                    element?.entries[0]?.orderEntry?.entryNumber &&
                  obj.statusDate === element?.statusDate &&
                  obj.status === element?.status
                ) {
                  element.entries[0].shippedQuantity =
                    element.entries[0].shippedQuantity +
                    obj.entries[0].shippedQuantity;
                  obj.entries[0].orderEntry.product.variantOptions[0][
                    'productUnits'
                  ] = obj.entries[0].shippedQuantity;
                  obj.entries[0].orderEntry.product.variantOptions[0][
                    'productDoses'
                  ] =
                    obj.entries[0].shippedQuantity *
                    obj.entries[0].orderEntry.product.quantityPerUnit;
                  element.entries[0].orderEntry.product.variantOptions.push(
                    ...obj.entries[0].orderEntry.product.variantOptions
                  );
                } else {
                  element.entries[0].orderEntry.product.variantOptions[0][
                    'productUnits'
                  ] = obj.entries[0].shippedQuantity;
                  element.entries[0].orderEntry.product.variantOptions[0][
                    'productDoses'
                  ] =
                    obj.entries[0].shippedQuantity *
                    obj.entries[0].orderEntry.product.quantityPerUnit;
                }
                if (
                  index === uniqueConsignArr.length - 1 &&
                  j === orderDetails['consignments'].length - 1
                ) {
                  orderDetails['aggregatedConsignmentData'] = uniqueConsignArr;
                  orderDetails['entries'].forEach((entry) => {
                    let filterConsiByEntryNum = orderDetails[
                      'aggregatedConsignmentData'
                    ].filter(
                      (element) =>
                        element.entries[0].orderEntry.entryNumber ==
                        entry.entryNumber
                    );
                    entry['finalConsignment'] = filterConsiByEntryNum;
                  });
                }
              });
            });
          }
        });
      }

      //C) Taking unconsigned Entries
      this.orderDetails?.unconsignedEntries?.forEach((uncons, index) => {
        let dataObj = {};
        dataObj['productCode'] = uncons?.product?.code;
        dataObj['productName'] = uncons?.product?.variantProductDescription
          ? uncons?.product?.variantProductDescription
          : uncons?.product?.variantOptions?.length > 0
          ? uncons?.product?.variantOptions[0].description
          : uncons?.product?.description;
        dataObj['productName'] = dataObj['productName']?.replace(
          /<[^>]*>?/gm,
          ''
        );
        dataObj['productUnit'] = uncons?.quantity;
        dataObj['productDose'] =
          uncons.quantity * uncons?.product?.quantityPerUnit;
        dataObj['status'] = uncons?.quantityStatus;
        this.chartPopoverData.push(dataObj);
      });
      this.getTableDataNew2();
    }
  }

  influenzaChartDataNew(orderDetails) {
    let uniqueConsignArr = [];
    this.chartPopoverData = [];
    this.chartStatusPopoverData = [];
    if (orderDetails != null || orderDetails != undefined) {
      //showEditCTAShip not used in this component

      // //checking if all are shipped/completed and are part of consignment
      // if (
      //   orderDetails.hasOwnProperty('consignments') &&
      //   orderDetails['consignments'].length > 0
      //   && this.orderDetails?.entries?.length == orderDetails['consignments'].length
      // ) {
      //   this.showEditCTAShip = orderDetails['consignments'].every(
      //     (consignment) =>
      //       consignment.entries[0].orderEntry.quantityStatus.toLowerCase() ==
      //       'shipped'
      //   )
      //     ? false
      //     : true;
      // }
      // else{
      //   this.showEditCTAShip = this.orderDetails?.entries.every(
      //     (element) => element.quantityStatus.toLowerCase() == 'shipped'
      //   )
      //     ? false
      //     : true;
      // }

      this.orderDetails?.entries?.forEach((element, index) => {
        //if that entry is found in consignment
        // if (orderDetails?.consignments?.length > 0 && !element?.splittedRow){ //for splittedrow case, details are not showing in hover as consignment details are not present in entries with !hideRow
        //checking consignments only for shipped/completed entries
        if (
          orderDetails?.consignments?.length > 0 &&
          (element.quantityStatus.toLowerCase() == 'shipped' ||
            element.quantityStatus.toLowerCase() == 'completed')
        ) {
          //for splittedrow case, details are not showing in hover as consignment details are not present in entries with !hideRow
          let matchedConsignEntries = orderDetails['consignments'].filter(
            (cons) =>
              cons?.entries[0]?.orderEntry?.product?.code ==
              element.product.code
          );
          if (matchedConsignEntries?.length > 0) {
            matchedConsignEntries?.forEach((matchedconsignment) => {
              // now since split multiple entries is there for same product,due to this, it is getting pushed multiple times
              // let existingEntry =  this.chartPopoverData.find(item => item?.productCode==matchedconsignment?.entries[0]?.orderEntry?.product?.code
              //     && item?.productUnit == matchedconsignment?.entries[0]?.shippedQuantity
              //     && item?.status == matchedconsignment?.entries[0]?.orderEntry?.quantityStatus);
              // if(!existingEntry){
              let dataObj = {};
              dataObj['productCode'] =
                matchedconsignment?.entries[0]?.orderEntry?.product?.code;
              dataObj['productName'] =
                matchedconsignment?.entries[0]?.orderEntry?.product
                  ?.variantOptions?.length > 0
                  ? matchedconsignment?.entries[0]?.orderEntry?.product
                      ?.variantOptions[0]?.description
                  : matchedconsignment?.entries[0]?.orderEntry?.product
                      ?.description;
              dataObj['productName'] = dataObj['productName']?.replace(
                /<[^>]*>?/gm,
                ''
              );
              dataObj['productUnit'] =
                matchedconsignment?.entries[0]?.shippedQuantity;
              dataObj['productDose'] =
                matchedconsignment?.entries[0]?.shippedQuantity *
                matchedconsignment?.entries[0]?.orderEntry?.product
                  ?.quantityPerUnit;
              dataObj['status'] =
                matchedconsignment?.entries[0]?.orderEntry?.quantityStatus;
              this.chartPopoverData.push(dataObj);
              // }
            });
          } else {
            let dataObj = {};
            dataObj['productCode'] = element?.product?.code;
            dataObj['productName'] =
              element?.product?.variantOptions?.length > 0
                ? element?.product?.variantOptions[0]?.description
                : element?.product?.description;
            dataObj['productName'] = dataObj['productName']?.replace(
              /<[^>]*>?/gm,
              ''
            );
            dataObj['productUnit'] = element?.quantity;
            dataObj['productDose'] =
              element.quantity * element?.product?.quantityPerUnit;
            dataObj['status'] = element?.quantityStatus;
            this.chartPopoverData.push(dataObj);
          }
          // if (index + 1 === this.orderDetails?.entries.length){
          //   console.log('inside index + 1');
          //   uniqueConsignArr = orderDetails['consignments']?.reduce((unique, o) => {
          //     if (
          //       !unique?.some(
          //         (obj) =>
          //           obj?.entries[0]?.orderEntry?.entryNumber ===
          //             o?.entries[0]?.orderEntry?.entryNumber &&
          //           obj?.statusDate === o?.statusDate &&
          //           obj?.status === o?.status
          //       )
          //     ) {
          //       unique.push(o);
          //     }
          //     return unique;
          //   }, []);
          //   console.log('uniqueConsignArr',uniqueConsignArr);
          //   uniqueConsignArr?.forEach((element, index) => {
          //     orderDetails?.consignments?.forEach((obj, j) => {
          //       if (
          //         obj.code != element?.code &&
          //         obj.entries[0]?.orderEntry?.entryNumber ===
          //           element?.entries[0]?.orderEntry?.entryNumber &&
          //         obj.statusDate === element?.statusDate &&
          //         obj.status === element?.status
          //       ) {
          //         element.entries[0].shippedQuantity =
          //           element.entries[0].shippedQuantity +
          //           obj.entries[0].shippedQuantity;
          //         obj.entries[0].orderEntry.product.variantOptions[0][
          //           'productUnits'
          //         ] = obj.entries[0].shippedQuantity;
          //         obj.entries[0].orderEntry.product.variantOptions[0][
          //           'productDoses'
          //         ] =
          //           obj.entries[0].shippedQuantity *
          //           obj.entries[0].orderEntry.product.quantityPerUnit;
          //         element.entries[0].orderEntry.product.variantOptions.push(
          //           ...obj.entries[0].orderEntry.product.variantOptions
          //         );
          //       } else {
          //         element.entries[0].orderEntry.product.variantOptions[0][
          //           'productUnits'
          //         ] = obj.entries[0].shippedQuantity;
          //         element.entries[0].orderEntry.product.variantOptions[0][
          //           'productDoses'
          //         ] =
          //           obj.entries[0].shippedQuantity *
          //           obj.entries[0].orderEntry.product.quantityPerUnit;
          //       }
          //       if (
          //         index === uniqueConsignArr.length - 1 &&
          //         j === orderDetails['consignments'].length - 1
          //       ) {
          //         orderDetails['aggregatedConsignmentData'] = uniqueConsignArr;
          //         orderDetails['entries'].forEach((entry) => {
          //           let filterConsiByEntryNum = orderDetails[
          //             'aggregatedConsignmentData'
          //           ].filter(
          //             (element) =>
          //               element.entries[0].orderEntry.entryNumber ==
          //               entry.entryNumber
          //           );
          //           entry['finalConsignment'] = filterConsiByEntryNum;
          //         });
          //       }
          //     });
          //   });
          // }
        } else {
          let dataObj = {};
          dataObj['productCode'] = element?.product?.code;
          dataObj['productName'] =
            element?.product?.variantOptions?.length > 0
              ? element?.product?.variantOptions[0].description
              : element?.product?.description;
          dataObj['productName'] = dataObj['productName']?.replace(
            /<[^>]*>?/gm,
            ''
          );
          dataObj['productUnit'] = element?.quantity;
          dataObj['productDose'] =
            element.quantity * element?.product?.quantityPerUnit;
          dataObj['status'] = element?.quantityStatus;
          this.chartPopoverData.push(dataObj);
        }
        if (index + 1 === this.orderDetails?.entries.length) {
          uniqueConsignArr = orderDetails['consignments']?.reduce(
            (unique, o) => {
              if (
                !unique?.some(
                  (obj) =>
                    obj?.entries[0]?.orderEntry?.entryNumber ===
                      o?.entries[0]?.orderEntry?.entryNumber &&
                    obj?.statusDate === o?.statusDate &&
                    obj?.status === o?.status
                )
              ) {
                unique.push(o);
              }
              return unique;
            },
            []
          );
          uniqueConsignArr?.forEach((element, index) => {
            orderDetails?.consignments?.forEach((obj, j) => {
              if (
                obj.code != element?.code &&
                obj.entries[0]?.orderEntry?.entryNumber ===
                  element?.entries[0]?.orderEntry?.entryNumber &&
                obj.statusDate === element?.statusDate &&
                obj.status === element?.status
              ) {
                element.entries[0].shippedQuantity =
                  element.entries[0].shippedQuantity +
                  obj.entries[0].shippedQuantity;
                obj.entries[0].orderEntry.product.variantOptions[0][
                  'productUnits'
                ] = obj.entries[0].shippedQuantity;
                obj.entries[0].orderEntry.product.variantOptions[0][
                  'productDoses'
                ] =
                  obj.entries[0].shippedQuantity *
                  obj.entries[0].orderEntry.product.quantityPerUnit;
                element.entries[0].orderEntry.product.variantOptions.push(
                  ...obj.entries[0].orderEntry.product.variantOptions
                );
              } else {
                element.entries[0].orderEntry.product.variantOptions[0][
                  'productUnits'
                ] = obj.entries[0].shippedQuantity;
                element.entries[0].orderEntry.product.variantOptions[0][
                  'productDoses'
                ] =
                  obj.entries[0].shippedQuantity *
                  obj.entries[0].orderEntry.product.quantityPerUnit;
              }
              if (
                index === uniqueConsignArr.length - 1 &&
                j === orderDetails['consignments'].length - 1
              ) {
                orderDetails['aggregatedConsignmentData'] = uniqueConsignArr;
                orderDetails['entries'].forEach((entry) => {
                  let filterConsiByEntryNum = orderDetails[
                    'aggregatedConsignmentData'
                  ].filter(
                    (element) =>
                      element.entries[0].orderEntry.entryNumber ==
                      entry.entryNumber
                  );
                  entry['finalConsignment'] = filterConsiByEntryNum;
                });
              }
            });
          });
        }
      });
      this.getTableData();
    }
  }

  influenzaChartData(orderDetails) {
    let uniqueConsignArr = [];
    this.chartPopoverData = [];
    this.chartStatusPopoverData = [];
    //if consignment present then filter unique consignments
    if (orderDetails != null || orderDetails != undefined) {
      if (
        orderDetails.hasOwnProperty('consignments') &&
        orderDetails['consignments'].length > 0 &&
        this.orderDetails?.entries?.length ==
          orderDetails['consignments'].length
      ) {
        //above last length comparison condition added , otherwise sometimes consignments has quite less data than shown in dashbboard shipment table causing data in chart to be different than in table
        this.showEditCTAShip = orderDetails?.consignments?.every(
          (consignment) =>
            consignment.entries[0].orderEntry.quantityStatus.toLowerCase() ==
            'shipped'
        )
          ? false
          : true;
        orderDetails['consignments'].forEach((consignment) => {
          let dataObj = {};
          dataObj['productCode'] =
            consignment.entries[0].orderEntry.product.code;
          dataObj['productName'] =
            consignment.entries[0].orderEntry.product.variantOptions[0].description;
          dataObj['productName'] = dataObj['productName'].replace(
            /<[^>]*>?/gm,
            ''
          );
          dataObj['productUnit'] = consignment.entries[0].shippedQuantity;
          dataObj['productDose'] =
            consignment.entries[0].shippedQuantity *
            consignment.entries[0].orderEntry.product.quantityPerUnit;
          dataObj['status'] = consignment.entries[0].orderEntry.quantityStatus;
          this.chartPopoverData.push(dataObj);
        });
        uniqueConsignArr = orderDetails['consignments'].reduce((unique, o) => {
          if (
            !unique.some(
              (obj) =>
                obj.entries[0]?.orderEntry?.entryNumber ===
                  o.entries[0]?.orderEntry?.entryNumber &&
                obj.statusDate === o.statusDate &&
                obj.status === o.status
            )
          ) {
            unique.push(o);
          }
          return unique;
        }, []);
        // order
        uniqueConsignArr.forEach((element, index) => {
          orderDetails['consignments'].forEach((obj, j) => {
            if (
              obj.code != element.code &&
              obj.entries[0]?.orderEntry?.entryNumber ===
                element.entries[0]?.orderEntry?.entryNumber &&
              obj.statusDate === element.statusDate &&
              obj.status === element.status
            ) {
              element.entries[0].shippedQuantity =
                element.entries[0].shippedQuantity +
                obj.entries[0].shippedQuantity;
              obj.entries[0].orderEntry.product.variantOptions[0][
                'productUnits'
              ] = obj.entries[0].shippedQuantity;
              obj.entries[0].orderEntry.product.variantOptions[0][
                'productDoses'
              ] =
                obj.entries[0].shippedQuantity *
                obj.entries[0].orderEntry.product.quantityPerUnit;
              element.entries[0].orderEntry.product.variantOptions.push(
                ...obj.entries[0].orderEntry.product.variantOptions
              );
            } else {
              element.entries[0].orderEntry.product.variantOptions[0][
                'productUnits'
              ] = obj.entries[0].shippedQuantity;
              element.entries[0].orderEntry.product.variantOptions[0][
                'productDoses'
              ] =
                obj.entries[0].shippedQuantity *
                obj.entries[0].orderEntry.product.quantityPerUnit;
            }
            if (
              index === uniqueConsignArr.length - 1 &&
              j === orderDetails['consignments'].length - 1
            ) {
              orderDetails['aggregatedConsignmentData'] = uniqueConsignArr;
              orderDetails['entries'].forEach((entry) => {
                let filterConsiByEntryNum = orderDetails[
                  'aggregatedConsignmentData'
                ].filter(
                  (element) =>
                    element.entries[0].orderEntry.entryNumber ==
                    entry.entryNumber
                );
                entry['finalConsignment'] = filterConsiByEntryNum;
              });
            }
          });
        });
        this.getTableData();
      } else {
        this.getTableData();
        this.showEditCTAShip = this.orderDetails?.entries?.every(
          (element) => element.quantityStatus.toLowerCase() == 'shipped'
        )
          ? false
          : true;
        this.orderDetails?.entries?.forEach((element) => {
          let dataObj = {};
          dataObj['productCode'] = element.product.code;
          dataObj['productName'] =
            element.product.variantOptions[0].description;
          dataObj['productName'] = dataObj['productName'].replace(
            /<[^>]*>?/gm,
            ''
          );
          dataObj['productUnit'] = element.quantity;
          dataObj['productDose'] =
            element.quantity * element.product.quantityPerUnit;
          dataObj['status'] = element.quantityStatus;
          this.chartPopoverData.push(dataObj);
        });
      }
    }
  }

  openTrackingURL(trackingNumber, trackingURL) {
    window.open(trackingURL.replace('<TRACKN>', trackingNumber));
  }

  //Method added for STS case - Manage Shipping schedule
  redirectToShippingSchedule() {
    let listeningParent = 'dashboard'; //default
    if (this.urlPath == 'reservation-overview') {
      listeningParent = 'reservation-overview';
    }
    this.manageSts.emit(listeningParent);
  }

  viewAllShipments() {
    this.reservationData = JSON.parse(
      JSON.stringify(this.reservationTableData)
    );
  }

  getTableDataNew2() {
    this.reservationData = [];
    this.reservationTableData = [];
    this.doughnutChartLabels = [];
    this.doughnutChartData = [];
    this.chartColors = [];
    this.chartsBgColorArray = [];
    this.chartCenterUnits = 0;
    this.orderDetails?.entries?.forEach((element, index) => {
      if (!this.doughnutChartLabels.includes(element.quantityStatus)) {
        this.doughnutChartLabels.push(element.quantityStatus);
      }
      if (element.finalConsignment && element.finalConsignment.length > 0) {
        element.finalConsignment.forEach((consignment) => {
          let obj = {};

          let shipmentStatus;
          if (
            consignment?.entries[0]?.orderEntry?.quantityStatus?.toLowerCase() ==
              'shipped' ||
            consignment?.entries[0]?.orderEntry?.quantityStatus?.toLowerCase() ==
              'completed'
          ) {
            shipmentStatus =
              consignment?.entries[0]?.orderEntry?.quantityStatus;
          } else {
            shipmentStatus = 'Shipped';
          }
          // obj['shipmentStatus'] = element['quantityStatus'];
          // let statArr = this.colorsArr.filter(
          //   (stat) => stat.status == element['quantityStatus']
          // );
          obj['shipmentStatus'] = shipmentStatus;
          let statArr = this.colorsArr.filter(
            (stat) => stat.status == shipmentStatus
          );
          obj['statusColor'] = statArr.length > 0 ? statArr[0].color : '';
          obj['shipDate'] = consignment?.statusDate.substring(0, 10);
          obj['trackingId'] = consignment?.trackingID;
          obj['trackingURL'] = consignment?.trackingURL;
          obj['unit'] = consignment.entries[0]?.shippedQuantity;
          obj['doses'] =
            consignment.entries[0]?.shippedQuantity *
            element?.product?.quantityPerUnit;
          obj['invoice'] =
            element.invoices.length > 0
              ? element?.invoices[0]?.invoiceNumber
              : '';
          obj['carrier'] = consignment?.carrierDetails;
          obj['products'] = [
            {
              code: consignment.entries[0].orderEntry.product.code,
              description:
                consignment.entries[0].orderEntry.product.variantOptions[0].description.replace(
                  /<[^>]*>?/gm,
                  ''
                ),
              productUnits: consignment.entries[0].shippedQuantity,
              productDoses:
                consignment.entries[0].shippedQuantity *
                consignment.entries[0].orderEntry.product.quantityPerUnit,
              // status: consignment.entries[0].orderEntry.quantityStatus,
              status: shipmentStatus,
            },
          ];
          this.reservationTableData.push(obj);

          let differenceQty =
            consignment?.entries[0]?.orderEntry?.quantity -
            consignment?.entries[0]?.shippedQuantity;
          //now if not all quantities under consignment are shipped, remaining quantity status to get from entries
          if (differenceQty > 0) {
            let obj = {};
            obj['shipmentStatus'] = element['quantityStatus'];
            let statArr = this.colorsArr.filter(
              (stat) => stat.status == element['quantityStatus']
            );
            obj['statusColor'] = statArr.length > 0 ? statArr[0].color : '';
            obj['shipDate'] =
              element['quantityStatus'] == 'TBD'
                ? 'TBD'
                : element['estimatedDeliveryDate'];
            obj['trackingId'] = '';
            obj['trackingURL'] = '';
            obj['unit'] = differenceQty;
            obj['doses'] = differenceQty * element?.product?.quantityPerUnit;
            obj['products'] = [
              {
                code: element.product.code,
                description:
                  element.product.variantOptions[0].description.replace(
                    /<[^>]*>?/gm,
                    ''
                  ),
                productUnits: differenceQty,
                productDoses: differenceQty * element?.product?.quantityPerUnit,
                status: element?.quantityStatus,
              },
            ];
            if (this.reservationTableData.length > 0) {
              let objExistsIndex = this.reservationTableData.findIndex(
                (element) =>
                  element['shipmentStatus'] == obj['shipmentStatus'] &&
                  element['shipDate'] == obj['shipDate']
              );
              if (objExistsIndex != -1) {
                this.reservationTableData[objExistsIndex]['unit'] =
                  this.reservationTableData[objExistsIndex]['unit'] +
                  obj['unit'];
                this.reservationTableData[objExistsIndex]['doses'] =
                  this.reservationTableData[objExistsIndex]['doses'] +
                  obj['doses'];
              } else {
                this.reservationTableData.push(obj);
              }
            } else {
              this.reservationTableData.push(obj);
            }
          }
        });
        // //US14439-filtering out cancelled line items
        // this.reservationTableData = this.reservationTableData?.filter(item => item?.shipmentStatus != 'Cancelled');
        // this.reservationData = JSON.parse(
        //   JSON.stringify(this.reservationTableData.slice(0, 4))
        // );
      }
    });

    this.orderDetails?.unconsignedEntries?.forEach((uncons, index) => {
      let obj = {};
      obj['shipmentStatus'] = uncons['quantityStatus'];
      let statArr = this.colorsArr.filter(
        (stat) => stat.status == uncons['quantityStatus']
      );
      obj['statusColor'] = statArr.length > 0 ? statArr[0].color : '';
      obj['shipDate'] =
        uncons['quantityStatus'] == 'TBD'
          ? 'TBD'
          : uncons['estimatedDeliveryDate'];
      obj['trackingId'] = '';
      obj['trackingURL'] = '';
      obj['unit'] = uncons?.quantity;
      obj['doses'] = uncons?.quantity * uncons?.product?.quantityPerUnit;
      obj['products'] = [
        {
          code: uncons.product.code,
          description: uncons.product.variantOptions[0].description.replace(
            /<[^>]*>?/gm,
            ''
          ),
          productUnits: uncons?.quantity,
          productDoses: uncons?.quantity * uncons?.product?.quantityPerUnit,
          status: uncons?.quantityStatus,
        },
      ];
      if (this.reservationTableData.length > 0) {
        let objExistsIndex = this.reservationTableData.findIndex(
          (element) =>
            element['shipmentStatus'] == obj['shipmentStatus'] &&
            element['shipDate'] == obj['shipDate']
        );
        if (objExistsIndex != -1) {
          this.reservationTableData[objExistsIndex]['unit'] =
            this.reservationTableData[objExistsIndex]['unit'] + obj['unit'];
          this.reservationTableData[objExistsIndex]['doses'] =
            this.reservationTableData[objExistsIndex]['doses'] + obj['doses'];
        } else {
          this.reservationTableData.push(obj);
        }
      } else {
        this.reservationTableData.push(obj);
      }
    });
    //US14439-filtering out cancelled line items
    this.reservationTableData = this.reservationTableData?.filter(
      (item) => item?.shipmentStatus != 'Cancelled'
    );
    this.reservationData = this.reservationTableData.slice(0, 5);
    let objdata = {};
    this.totalUnits = 0;
    this.totalDoses = 0;
    this.chartCenterDoses = this.reservationTableData.reduce(
      (total, obj) => obj.doses + total,
      0
    );
    this.chartPrevCenterDoses = this.chartCenterDoses;
    this.chartCenterUnits = this.reservationTableData.reduce(
      (total, obj) => obj.unit + total,
      0
    );
    if (
      this.reservationTableData?.every(
        (element) =>
          element.shipmentStatus == this.reservationTableData[0]?.shipmentStatus
      )
    ) {
      this.chartCenterStatus = this.reservationTableData[0]?.shipmentStatus;
      this.chartPrevCenterUnits = this.chartCenterUnits;
      this.chartPrevCenterStatus = this.chartCenterStatus;
    } else {
      this.chartCenterStatus = 'Confirmed';
      this.chartPrevCenterUnits = this.chartCenterUnits;
      this.chartPrevCenterStatus = this.chartCenterStatus;
    }
    // if (
    //   this.reservationTableData.some(
    //     (element) => element.shipmentStatus == 'Shipped'
    //   )
    // ) {
    //   let filterArr = this.reservationTableData.filter(
    //     (element) => element.shipmentStatus == 'Shipped'
    //   );
    //   this.chartCenterUnits = filterArr.reduce(
    //     (total, obj) => obj.unit + total,
    //     0
    //   );
    //   this.chartCenterStatus = 'Shipped';
    //   this.chartPrevCenterUnits = this.chartCenterUnits;
    //   this.chartPrevCenterStatus = this.chartCenterStatus;
    // } else if (
    //   this.reservationTableData.some(
    //     (element) => element.shipmentStatus == 'Scheduled'
    //   )
    // ) {
    //   let filterArr = this.reservationTableData.filter(
    //     (element) => element.shipmentStatus == 'Scheduled'
    //   );
    //   this.chartCenterUnits = filterArr.reduce(
    //     (total, obj) => obj.unit + total,
    //     0
    //   );
    //   this.chartCenterStatus = 'Scheduled';
    //   this.chartPrevCenterUnits = this.chartCenterUnits;
    //   this.chartPrevCenterStatus = this.chartCenterStatus;
    // } else if (
    //   this.reservationTableData.some(
    //     (element) => element.shipmentStatus == 'TBD'
    //   )
    // ) {
    //   let filterArr = this.reservationTableData.filter(
    //     (element) => element.shipmentStatus == 'TBD'
    //   );
    //   this.chartCenterUnits = filterArr.reduce(
    //     (total, obj) => obj.unit + total,
    //     0
    //   );
    //   this.chartCenterStatus = 'TBD';
    //   this.chartPrevCenterUnits = this.chartCenterUnits;
    //   this.chartPrevCenterStatus = this.chartCenterStatus;
    // }
    this.doughnutDataSet = {
      data: [],
      backgroundColor: [],
      hoverBackgroundColor: [],
      labels: [],
    };
    this.doughnutChartLabels.forEach((label, index) => {
      this.setChartColor(label, index);
      let filterArr = this.reservationTableData.filter(
        (element) => element.shipmentStatus == label
      );
      let datapoint = filterArr.reduce((accumulator, object) => {
        console.log('add', 'acc--',accumulator, 'obj--',object.doses)
        return accumulator + object.doses;
      }, 0);

      this.doughnutDataSet.data.push(datapoint);
      if (index == this.doughnutChartLabels.length - 1) {
        this.showPieChart = true;
      }
    });
    // this.doughnutChartData['backgroundColor']=this.chartColors[0]?.backgroundColor;
    // this.doughnutDataSet.backgroundColor.push(this.chartColors[0]?.backgroundColor);
    // this.doughnutDataSet.hoverBackgroundColor.push(this.chartColors[0]?.backgroundColor);
    // this.doughnutDataSet.labels.push(this.doughnutChartLabels);
    this.doughnutDataSet.backgroundColor = this.chartColors[0]?.backgroundColor;
    this.doughnutDataSet.hoverBackgroundColor =
      this.chartColors[0]?.backgroundColor;
    this.doughnutDataSet.labels = this.doughnutChartLabels;
    this.doughnutChartData?.push(this.doughnutDataSet);
    this.fluchart?.update();
    this.cdr.detectChanges();
  }

  getTableData() {
    this.reservationData = [];
    this.reservationTableData = [];
    this.doughnutChartLabels = [];
    this.doughnutChartData = [];
    this.chartColors = [];
    this.chartsBgColorArray = [];
    this.chartCenterUnits = 0;
    this.orderDetails?.entries?.forEach((element, index) => {
      if (!this.doughnutChartLabels.includes(element.quantityStatus)) {
        this.doughnutChartLabels.push(element.quantityStatus);
      }
      if (element.finalConsignment && element.finalConsignment.length > 0) {
        element.finalConsignment.forEach((consignment) => {
          let obj = {};
          obj['shipmentStatus'] = element['quantityStatus'];
          let statArr = this.colorsArr.filter(
            (stat) => stat.status == element['quantityStatus']
          );
          obj['statusColor'] = statArr.length > 0 ? statArr[0].color : '';
          obj['shipDate'] = consignment?.statusDate.substring(0, 10);
          obj['trackingId'] = consignment?.trackingID;
          obj['trackingURL'] = consignment?.trackingURL;
          obj['unit'] = consignment.entries[0]?.shippedQuantity;
          obj['doses'] =
            consignment.entries[0]?.shippedQuantity *
            element?.product?.quantityPerUnit;
          obj['invoice'] =
            element.invoices.length > 0
              ? element?.invoices[0]?.invoiceNumber
              : '';
          obj['carrier'] = consignment?.carrierDetails;
          obj['products'] = [
            {
              code: consignment.entries[0].orderEntry.product.code,
              description:
                consignment.entries[0].orderEntry.product.variantOptions[0].description.replace(
                  /<[^>]*>?/gm,
                  ''
                ),
              productUnits: consignment.entries[0].shippedQuantity,
              productDoses:
                consignment.entries[0].shippedQuantity *
                consignment.entries[0].orderEntry.product.quantityPerUnit,
              status: consignment.entries[0].orderEntry.quantityStatus,
            },
          ];
          this.reservationTableData.push(obj);
        });
        //US14439-filtering out cancelled line items
        this.reservationTableData = this.reservationTableData?.filter(
          (item) => item?.shipmentStatus != 'Cancelled'
        );
        this.reservationData = JSON.parse(
          JSON.stringify(this.reservationTableData.slice(0, 4))
        );
      } else {
        let obj = {};
        obj['shipmentStatus'] = element['quantityStatus'];
        let statArr = this.colorsArr.filter(
          (stat) => stat.status == element['quantityStatus']
        );
        obj['statusColor'] = statArr.length > 0 ? statArr[0].color : '';
        obj['shipDate'] =
          element['quantityStatus'] == 'TBD'
            ? 'TBD'
            : element['estimatedDeliveryDate'];
        obj['trackingId'] = '';
        obj['trackingURL'] = '';
        obj['unit'] = element?.quantity;
        obj['doses'] = element?.quantity * element?.product?.quantityPerUnit;
        obj['products'] = [
          {
            code: element.product.code,
            description: element.product.variantOptions[0].description.replace(
              /<[^>]*>?/gm,
              ''
            ),
            productUnits: element?.quantity,
            productDoses: element?.quantity * element?.product?.quantityPerUnit,
            status: element?.quantityStatus,
          },
        ];
        if (this.reservationTableData.length > 0) {
          let objExistsIndex = this.reservationTableData.findIndex(
            (element) =>
              element['shipmentStatus'] == obj['shipmentStatus'] &&
              element['shipDate'] == obj['shipDate']
          );
          if (objExistsIndex != -1) {
            this.reservationTableData[objExistsIndex]['unit'] =
              this.reservationTableData[objExistsIndex]['unit'] + obj['unit'];
            this.reservationTableData[objExistsIndex]['doses'] =
              this.reservationTableData[objExistsIndex]['doses'] + obj['doses'];
          } else {
            this.reservationTableData.push(obj);
          }
        } else {
          this.reservationTableData.push(obj);
        }
        //US14439-filtering out cancelled line items
        this.reservationTableData = this.reservationTableData?.filter(
          (item) => item?.shipmentStatus != 'Cancelled'
        );
        this.reservationData = this.reservationTableData.slice(0, 5);
      }
    });
    let objdata = {};
    this.totalUnits = 0;
    this.totalDoses = 0;
    this.chartCenterDoses = this.reservationTableData.reduce(
      (total, obj) => obj.doses + total,
      0
    );
    this.chartPrevCenterDoses = this.chartCenterDoses;
    this.chartCenterUnits = this.reservationTableData.reduce(
      (total, obj) => obj.unit + total,
      0
    );
    if (
      this.reservationTableData?.every(
        (element) =>
          element.shipmentStatus == this.reservationTableData[0]?.shipmentStatus
      )
    ) {
      this.chartCenterStatus = this.reservationTableData[0]?.shipmentStatus;
      this.chartPrevCenterUnits = this.chartCenterUnits;
      this.chartPrevCenterStatus = this.chartCenterStatus;
    } else {
      this.chartCenterStatus = 'Confirmed';
      this.chartPrevCenterUnits = this.chartCenterUnits;
      this.chartPrevCenterStatus = this.chartCenterStatus;
    }
    // if (
    //   this.reservationTableData.some(
    //     (element) => element.shipmentStatus == 'Shipped'
    //   )
    // ) {
    //   let filterArr = this.reservationTableData.filter(
    //     (element) => element.shipmentStatus == 'Shipped'
    //   );
    //   this.chartCenterUnits = filterArr.reduce(
    //     (total, obj) => obj.unit + total,
    //     0
    //   );
    //   this.chartCenterStatus = 'Shipped';
    //   this.chartPrevCenterUnits = this.chartCenterUnits;
    //   this.chartPrevCenterStatus = this.chartCenterStatus;
    // } else if (
    //   this.reservationTableData.some(
    //     (element) => element.shipmentStatus == 'Scheduled'
    //   )
    // ) {
    //   let filterArr = this.reservationTableData.filter(
    //     (element) => element.shipmentStatus == 'Scheduled'
    //   );
    //   this.chartCenterUnits = filterArr.reduce(
    //     (total, obj) => obj.unit + total,
    //     0
    //   );
    //   this.chartCenterStatus = 'Scheduled';
    //   this.chartPrevCenterUnits = this.chartCenterUnits;
    //   this.chartPrevCenterStatus = this.chartCenterStatus;
    // } else if (
    //   this.reservationTableData.some(
    //     (element) => element.shipmentStatus == 'TBD'
    //   )
    // ) {
    //   let filterArr = this.reservationTableData.filter(
    //     (element) => element.shipmentStatus == 'TBD'
    //   );
    //   this.chartCenterUnits = filterArr.reduce(
    //     (total, obj) => obj.unit + total,
    //     0
    //   );
    //   this.chartCenterStatus = 'TBD';
    //   this.chartPrevCenterUnits = this.chartCenterUnits;
    //   this.chartPrevCenterStatus = this.chartCenterStatus;
    // }
    this.doughnutChartLabels.forEach((label, index) => {
      this.setChartColor(label, index);
      let filterArr = this.reservationTableData.filter(
        (element) => element.shipmentStatus == label
      );
      this.doughnutChartData.push(
        filterArr.reduce((accumulator, object) => {
          return accumulator + object.doses;
        }, 0)
      );
      if (index == this.doughnutChartLabels.length - 1) {
        this.showPieChart = true;
      }
    });
    this.cdr.detectChanges();
  }

  sortColumn(event, fieldName, dataList, type): any {
    this.reservationData = CommonUtils.onSortClick(
      event,
      fieldName,
      dataList,
      type
    ); // Column Sorting
  }

  downloadInvoice(invoiceNo) {
    this.influenzaService.downloadInvoicePdf(invoiceNo);
  }

  downloadXLS() {
    this.xlsDataArr = [];
    //this.reservationTableData.forEach((reservation) => {
    let downloadData = this.orderDetails.entries.filter(
      (element) => element?.quantityStatus.toLowerCase() != 'cancelled'
    );
    downloadData.forEach((reservation, i) => {
      //   let dataObj = {
      //     'Shipment Status': reservation.shipmentStatus,
      //     'Ship Date': reservation.shipDate,
      //     Unit: reservation.unit,
      //     Doses: reservation.doses,
      //     'Tracking ID': reservation.trackingId,
      //   };
      // let dataObj1 = {
      //   'Customer': this.orderDetails.shipToLoc_id,
      //   'Material': reservation?.products?.length > 0 ? reservation.products[0].code : '',
      //   'Units/Doses': reservation.unit + "/" + reservation.doses,
      //   'Estimated Ship Date': reservation.shipmentStatus == 'TBD' ? 'TBD' : reservation.shipDate,
      //   'PO #': this.orderDetails.purchaseOrderNumber
      // };
      let dataObj1 = {
        Customer: this.orderDetails.shipToLoc_id,
        Material: reservation.product.code,
        'Units/Doses':
          reservation.quantity +
          '/' +
          reservation.quantity * reservation.product.quantityPerUnit,
        'Estimated Ship Date':
          reservation.quantityStatus == 'TBD'
            ? 'TBD'
            : reservation.estimatedDeliveryDate.split('T')[0],
        'PO #': this.orderDetails.purchaseOrderNumber,
      };
      this.xlsDataArr.push(dataObj1);
    });
    // this.influenzaService.downloadXls(this.xlsDataArr, 'InfluenzaReservation_' + this.orderDetails.guid);
    this.influenzaService.downloadXls(this.xlsDataArr, 'ReserveOverview');

    //to allow wrapping of text as well
    // this.influenzaService.downloadXlsFixWidthWrapText(
    //   this.xlsDataArr,
    //   'ReserveOverview',
    //   5
    // );
  }

  setStatusColorCode(status) {
    // this.selectedStatus = status;
    // this.chartStatusPopoverData = this.chartPopoverData.filter(
    //   (element) => element.status == this.selectedStatus
    // );
    if (status === 'Shipped') {
      this.statusColorCode = '#62D488';
      this.cdr.detectChanges();
    } else if (status === 'Pending') {
      this.statusColorCode = '#7A00E6';
      this.cdr.detectChanges();
    } else if (status === 'Scheduled') {
      this.statusColorCode = '#23004C';
      this.cdr.detectChanges();
    } else if (status === 'In process') {
      this.statusColorCode = '#8ED8EA';
      this.cdr.detectChanges();
    } else if (status === 'TBD') {
      this.statusColorCode = '#C7C8CA';
      this.cdr.detectChanges();
    } else if (status === 'Cancelled') {
      this.statusColorCode = '#D3D3D3';
      this.cdr.detectChanges();
    } else if (status === 'Open') {
      this.statusColorCode = '#2EA857';
      this.cdr.detectChanges();
    } else if (status === 'Completed') {
      this.statusColorCode = '#04832e';
      this.cdr.detectChanges();
    } else {
      this.statusColorCode = '#F4F2F6'; // when no status
      this.cdr.detectChanges();
    }
    // if(index == (this.reservationData.length -1)){
    // }
  }

  setChartColor(status, index) {
    if (status === 'Shipped') {
      this.chartsBgColorArray.push('#62D488');
    } else if (status === 'Pending') {
      this.chartsBgColorArray.push('#7A00E6');
    } else if (status === 'Scheduled') {
      this.chartsBgColorArray.push('#23004C');
    } else if (status === 'In process') {
      this.chartsBgColorArray.push('#8ED8EA');
    } else if (status === 'TBD') {
      this.chartsBgColorArray.push('#C7C8CA');
    } else if (status === 'Cancelled') {
      this.chartsBgColorArray.push('#D3D3D3');
    } else if (status === 'Open') {
      this.chartsBgColorArray.push('#2EA857');
    } else if (status === 'Completed') {
      this.chartsBgColorArray.push('#04832e');
    } else {
      this.chartsBgColorArray.push('#F4F2F6'); // when no status
    }
    if (index === this.doughnutChartLabels.length - 1) {
      this.chartColors = [
        {
          backgroundColor: [...new Set(this.chartsBgColorArray)],
        },
      ];
      this.cdr.detectChanges();
    }
  }

  getStatusFromColor(color) {
    let hoverStatus;
    if (color === '#62D488') {
      hoverStatus = 'Shipped';
    } else if (color === '#7A00E6') {
      hoverStatus = 'Pending';
    } else if (color === '#23004C') {
      hoverStatus = 'Scheduled';
    } else if (color === '#8ED8EA') {
      hoverStatus = 'In process';
    } else if (color === '#C7C8CA') {
      hoverStatus = 'TBD';
    } else if (color === '#D3D3D3') {
      hoverStatus = 'Cancelled';
    } else if (color === '#2EA857') {
      hoverStatus = 'Open';
    } else if (color === '#04832e') {
      hoverStatus = 'Completed';
    } else {
      hoverStatus = '';
    }
    return hoverStatus;
  }

  navigateToTracking(id, url) {
    let a = url.split('<TRACKN>');
    this.fullTrackingUrl = a[0] + id;
  }

  groupAndSumUnits(data) {
    const groupedProducts = {};
    data?.forEach((product) => {
      const { productCode, productDose, productName, productUnit, status } =
        product;
      if (groupedProducts[productCode]) {
        groupedProducts[productCode].productDose += productDose;
        groupedProducts[productCode].productUnit += productUnit;
      } else {
        groupedProducts[productCode] = {
          productCode,
          productDose,
          productName,
          productUnit,
          status,
        };
      }
    });
    const result = Object.values(groupedProducts);
    return result;
  }
}
